'use strict';

var box = require('../../../../../../../../../../_virtual/box.cjs');
var accentColors = require('../../base/accentColors.cjs');

var hasRequiredBox;

function requireBox () {
	if (hasRequiredBox) return box.__exports;
	hasRequiredBox = 1;

	var accentColors$1 = accentColors.__require();

	var BOX_BASE_COLORS = /*#__PURE__*/ function(BOX_BASE_COLORS) {
	    BOX_BASE_COLORS["success"] = "success";
	    BOX_BASE_COLORS["system"] = "system";
	    BOX_BASE_COLORS["highlight"] = "highlight";
	    BOX_BASE_COLORS["danger"] = "danger";
	    BOX_BASE_COLORS["warning"] = "warning";
	    BOX_BASE_COLORS["info"] = "info";
	    return BOX_BASE_COLORS;
	}({});
	const BOX_COLORS = {
	    ...BOX_BASE_COLORS,
	    ...accentColors$1.AVIARY_ACCENTS
	};

	box.__exports.BOX_BASE_COLORS = BOX_BASE_COLORS;
	box.__exports.BOX_COLORS = BOX_COLORS;
	
	return box.__exports;
}

exports.__require = requireBox;
//# sourceMappingURL=box.cjs.map
